export const userIdentification = {
  FAILED_DUE_BLACKLISTED: 'FAILED_DUE_BLACKLISTED',
  FAILED_DUE_INVALID_PASSPORT: 'FAILED_DUE_INVALID_PASSPORT',
  FULL: 'FULL',
  FULL_DOSSIER: 'FULL_DOSSIER',
  READY: 'READY',
  UNIDENTIFIED: 'UNIDENTIFIED',
  FAILED: 'FAILED',
  SUPPORT_REVIEW: 'SUPPORT_REVIEW',
}

export const userIdxStatus = {
  IDX_TYPE_INVALID: 'IDX_TYPE_INVALID',
  IDX_TYPE_INITIAL: 'IDX_TYPE_INITIAL',
  IDX_TYPE_APPROVED: 'IDX_TYPE_APPROVED',
}
export const userIdxStatusTitle = {
  IDX_TYPE_INVALID: 'Отключен',
  IDX_TYPE_INITIAL: 'Подключен',
  IDX_TYPE_APPROVED: 'Пройден',
}

export const userIdentificationLabel = {
  [userIdentification.FAILED_DUE_BLACKLISTED]: 'В черном списке',
  [userIdentification.FAILED_DUE_INVALID_PASSPORT]: 'Невалидный паспорт',
  [userIdentification.FULL]: 'Упрощенная идентификация',
  [userIdentification.FULL_DOSSIER]: 'Полная идентификация',
  [userIdentification.READY]: 'В ожидании',
  [userIdentification.UNIDENTIFIED]: 'Нет',
  [userIdentification.FAILED]: 'Ошибка',
  [userIdentification.SUPPORT_REVIEW]: 'Проверка данных',
}

export const userIdentificationColor = {
  [userIdentification.FULL]: 'purple',
  [userIdentification.FULL_DOSSIER]: 'green',
  [userIdentification.UNIDENTIFIED]: 'gray',
  [userIdentification.READY]: 'gray',
  [userIdentification.FAILED]: 'red',
  [userIdentification.SUPPORT_REVIEW]: 'orange',
}

export const TYPE_USER_COUNTRY = {
  RUSSIA: 'Россия',
  ARMENIA: 'Армения',
}

export const TYPE_USER_PLATFORM = {
  ANDROID: 'Android',
  IPHONE: 'iPhone',
}

export const ROLES = {
  user: 'USER',
  admin: 'ADMIN',
  marketing: 'MARKETING',
}

export const ROLES_LABEL = {
  [ROLES.user]: 'Пользователь',
  [ROLES.admin]: 'Администратор',
  [ROLES.marketing]: 'Маркетинг',
}

export const typeStatus = {
  active: 'true',
  deactivated: 'false',
  blocked: 'blocked',
}

export const typeStatusTitle = {
  [typeStatus.active]: 'Активен',
  [typeStatus.deactivated]: 'Деактивирован',
  [typeStatus.blocked]: 'Заблокирован',
}

export const identityCountryOptions = Object.keys(TYPE_USER_COUNTRY).map((item) => ({
  value: item,
  label: TYPE_USER_COUNTRY[item],
}))

export const typeStatusOptions = [typeStatus.active, typeStatus.deactivated].map((item) => ({
  value: item,
  label: typeStatusTitle[item],
}))

export const getTypeStatus = ({ email, enabled }) => {
  if (email?.includes('_blocked')) {
    return typeStatus.blocked
  } else if (enabled === true) {
    return typeStatus.active
  } else if (enabled === false) {
    return typeStatus.deactivated
  } else if (enabled === undefined) {
    return null
  }
}
export const getTypeStatusTitle = (item) => {
  return typeStatusTitle[getTypeStatus(item)]
}

export const TYPE_ENABLED_COLOR = {
  true: 'blue',
  false: 'red',
}
